import React from 'react';
import Input from '..';

const Password = React.memo(props => <Input component="password" type="password" capsLock={false} {...props} autoComplete="new-password" />);

export default Password;
